document.addEventListener('DOMContentLoaded', function() {
  const isMobile = window.innerWidth <= 768;
  
  if (isMobile) {
    const dots = document.querySelectorAll('.testimonial-dot');
    const blocksWrapper = document.querySelector('.testimonials-blocks');
    const blocks = document.querySelectorAll('.testimonial-block');

    function updateActiveDot() {
      let activeIndex = 0;
      let minDiff = Infinity;

      blocks.forEach((block, index) => {
        const rect = block.getBoundingClientRect();
        const blockCenter = rect.left + rect.width / 2;
        const diff = Math.abs(blockCenter - window.innerWidth / 2);
        
        if (diff < minDiff) {
          minDiff = diff;
          activeIndex = index;
        }
      });

      dots.forEach(d => d.classList.remove('active'));
      dots[activeIndex].classList.add('active');
    }

    dots.forEach((dot, index) => {
      dot.addEventListener('click', function() {
        blocksWrapper.scrollTo({
          left: blocks[index].offsetLeft,
          behavior: 'smooth'
        });
      });
    });

    if (dots.length > 0) {
      dots[0].classList.add('active');
    }

    blocksWrapper.addEventListener('scroll', function() {
      updateActiveDot();
    });

    updateActiveDot();
  }
});